import {
  USER_INFO_SAVE_SUCCESS,
  SUBTRACT_CREDITS_SUCCESS,
  EDIT_USERNAME_EMAIL_REQUEST,
  EDIT_USERNAME_EMAIL_SUCCESS,
  EDIT_USERNAME_EMAIL_FAIL,
  USER_DELETE_SUCCESS,
  USER_SUB_DATA_UPDATE_FAIL,
  USER_SUB_DATA_UPDATE_REQUEST,
  USER_SUB_DATA_UPDATE_SUCCESS,
  CHEF_BASIC_INFO_SUCCESS,
} from "../reducerConsts/userConsts";

export const userDataReducer = (state = {}, action) => {

  switch(action.type){
    case SUBTRACT_CREDITS_SUCCESS:
      return {
        ...state,
        loginInfo: {
          ...state?.loginInfo,
          userCredits: state?.loginInfo?.userCredits - action.payload.subtractAmount
        }
      };
    case EDIT_USERNAME_EMAIL_REQUEST:
      return {
        ...state,
        loginInfo: {
          ...state?.loginInfo,
          basicInfoUpdating: true 
        }
      }
    case EDIT_USERNAME_EMAIL_SUCCESS:
      return {
        ...state,
        loginInfo: {
          ...state?.loginInfo,
          username: action.payload.username,
          email: action.payload.email,
          basicInfoUpdating: false
        }
      };
    case EDIT_USERNAME_EMAIL_FAIL:
      return {
        ...state,
        loginInfo: {
          ...state?.loginInfo,
          basicInfoError: action.payload,
          basicInfoUpdating: false
        }
      }
    case USER_INFO_SAVE_SUCCESS: 
      const{
        email,
        username,
        instagramLink,
        youtubeLink,
        bioContent,
        chefProfileAvatar,
      } = action.payload;

      return {
        ...state,
        loginInfo: action.payload,
        chefProfileInfo: {
          email: email,
          username: username,
          instagramLink: instagramLink,
          youtubeLink: youtubeLink,
          bioContent: bioContent,
          chefProfileAvatar: chefProfileAvatar,
        }
      };
    case USER_DELETE_SUCCESS:
      return {
        ...state,
        userProfileDeleted: true,
        loginInfo: {}
      }
    case USER_SUB_DATA_UPDATE_SUCCESS:
      return {
        ...state,
        loginInfo: {
          ...state.loginInfo,
          subscriptionStatus: action.payload.subscriptionStatus,
          subscriptionPriceId: action.payload.subscriptionPriceId,
          subscriptionProductId: action.payload.subscriptionProductId
        }
      }
    case CHEF_BASIC_INFO_SUCCESS:
      console.log('action payload', action.payload);
      return {
        ...state,
        chefProfileInfo: {
          ...state.chefProfileInfo,
          ...action.payload
        }
      }
    default: return {
      ...state
    };
  };
};